import AuthCard from "components/Auth/Card";
import OtpForm from "components/Auth/OtpForm";

function OTP() {
  return (
    <AuthCard
      title="Forgot Password"
      desc="Please enter your email to receive a verification link"
    >
      <OtpForm />
    </AuthCard>
  );
}

export default OTP;
